import { defineStore } from 'pinia'
import { alertBox } from '@/composables/silverBox';
import axios from 'axios';
import { convertToPersian, numberFormat } from '@/composables/digits';
// import { useProcessProduct } from '@/store/product'
export const useBasket = defineStore('basket', {
    state: () => {
        return {
            basketArray: [],
            supplierList: [],
            basketObject: '',
            basketUnavalibale: '',
            specialProducts: '',
            allItems: '',
            basketSupplierID: 0,
            primeAmount: 0,
            amount: 0,
            wareAmount: 0,
            virsual_amount: 0,
            discount: 0,
            regentProfit: 0,
            supplierDetail: { id: 0, name: '', minSale: 0, deliveryCost: 0 },
            basketFlag: '',
            useWalletFlag : false,
            isDamp : false,
            wallet : 0,
            isCustom : false,
            isCustomShown : false,
            customWallet : 0,
            location : '',
            coordinates : '',
            description : '',
            dampVal : '',
            rewardAmount : 0,
            useRewardFlag : false,
            finallFlag : true,
        }
    },
    getters: {
   
    },
    actions: {
        async getBasket() {
            this.finallFlag = true
            // گرفتن آرایه سبد خرید
            this.getLocalStorage();
            // اگر سبد خرید پر بود
            if (this.basketArray) {
                this.getBasketSupplierID()
                if (this.basketSupplierID) {
                    let index = this.basketArray.findIndex(elem => elem[2] == this.basketSupplierID)
                    if (this.basketArray[index]) {
                        var formdata = new FormData();
                        formdata.append("itemsId", this.basketArray[index][0]);
                        formdata.append("itemsCount", this.basketArray[index][1]);
                        let response = await fetch("https://radap.ir/Backend/api/section/basket/items.php",
                            {
                                method: 'POST',
                                body: formdata
                            })
                        let data = await response.json()
                        this.setBasketLocalStorage(data.basket, data.store.id)
                        // محصولات اصلی سبد خرید
                        this.basketObject = data.available;
                        // محصولات تمام شده سبد خرید
                        this.basketUnavalibale = data.unavailable;
                        // آیدی محصولات نهایی
                        this.allItems = data.all_items;
                        // محصولات یادت نره
                        this.specialProducts = data.special_products;

                        // قیمت های سبد خرید
                        this.primeAmount = data.prices.primeAmount
                        this.amount = data.prices.amount
                        this.discount = data.prices.discount
                        this.regentProfit = data.prices.regentProfit

                        // مشخصات فروشگاه سبد خرید
                        this.supplierDetail.id = data.store.id;
                        this.supplierDetail.name = data.store.name;
                        this.supplierDetail.minSale = data.store.minSale;
                        this.supplierDetail.deliveryCost = data.store.deliveryCost;

                        if (this.useWalletFlag) {
                           await this.getWallet()
                            this.amount -= this.wallet;
                        }
                        this.missingPrdocuts()
                        this.getLocation()

                    }
                }
            } else {
                this.basketFlag = false
            }
        },
        async getSupplierNames() {
            if (this.basketArray) {
                let supplier_ids = []
                this.basketArray.forEach(elem => {
                    supplier_ids.push(elem[2])
                })
                var formdata = new FormData();

                formdata.append("supplier_ids", supplier_ids);
                let response = await fetch("https://radap.ir/Backend/api/section/basket/suppliers_name.php",
                    {
                        method: 'POST',
                        body: formdata
                    })
                let data = await response.json()
                this.supplierList = data
            }
        },
        getLocalStorage() {
            this.basketArray = localStorage.getItem('basket');
            if (this.basketArray) {
                this.basketArray = JSON.parse(this.basketArray);
            }
        },
        setBasketSupplierID(id) {
            localStorage.setItem('bsID', id)
        },
        getBasketSupplierID() {
            if (localStorage.getItem('bsID')) {
                this.basketSupplierID = localStorage.getItem('bsID')
            }
        },
        getBasketPopup() {
            document.getElementById('basketModalBTN').click()
            this.expierDamp()
            this.clearDamp()
            this.setPaymentMethod(1)

        },
        setBasketLocalStorage(basket, supplierID) {
            if (basket[0].length == 0) {
                // سبدخرید خالی است
                this.basketFlag = false
                //   this.deleteBasket()
            } else {
                // سبد خرید پر است
                this.basketFlag = true;
                let storeBasketIndex = this.basketArray.findIndex(elem => elem[2] == supplierID)
                this.basketArray[storeBasketIndex] = basket
                localStorage.setItem('basket', JSON.stringify(this.basketArray))
            }
        },
        missingPrdocuts(){
            if(this.basketUnavalibale.length){
              document.getElementById('offcanvasProductsBTN').click()
            }
        },
        getLocation() {
            if(document.getElementById('locationHeaderTemp')) {
              this.location = document.getElementById('locationHeaderTemp').value
              this.coordinates = document.getElementById('locationCoordinatesHeaderTemp').value
            }
        },    
        async getWallet () {
            if(localStorage.getItem('userInfo')) {
                this.getBasketSupplierID()
                let response = await fetch('https://radap.ir/Backend/api/section/basket/wallet.php?user_id='+(JSON.parse(localStorage.getItem('userInfo'))[0]['id'])+'&supplier_id='+this.basketSupplierID)
                let data = await response.json()
                this.wallet = data.wallet
                this.isCustom = data.is_custom
                if(this.isCustom){
                    this.customWallet = data.custom_wallet
                    if(!this.isCustomShown){
                        this.getCustomWallet()
                    }
                }
            }
        },
        validDamp() {
            if (!localStorage.getItem('userInfo')) {
                alertBox('لطفا ابتدا وارد شوید.','error',2)
                document.querySelector('#basketForcMapModalCloseBTN').click();
                document.querySelector('#loginsModalBTN').click();
            }else if (this.useRewardFlag) {
              alertBox("در هر سفارش می توانید از یک کد تخفیف استفاده کنید")
            } else if (!this.dampVal) {
              alertBox('لطفا ابتدا کد تخفیف را وارد نمایید')
            } else {
              this.wareAmount = this.amount;
              if (this.supplierDetail.deliveryCost > 0) {
                this.wareAmount -= parseInt(this.supplierDetail.deliveryCost)
              }
              if (this.useWalletFlag) {
                this.wareAmount += parseInt(this.wallet)
              }
              axios
                .get('https://radap.ir/Backend/api/section/basket/damp.php?val=' + this.dampVal + '&user_id=' + JSON.parse(localStorage.getItem('userInfo'))[0]['id'] + '&supplier_id=' + this.supplierDetail.id + '&amount=' + this.wareAmount)
                .then(res => {
                  if (typeof (res.data) == 'string') {
                    if (res.data == 'notFound') {
                      alertBox('کد وارد شده اشتباه است')
                    } else if (res.data == 'notActive') {
                      alertBox('در حال حاضر این کد فعال نیست')
                    } else if (res.data == 'justFirst') {
                      alertBox('این کد تنها برای سفارش اول اعمال میشود')
                    } else if (res.data.includes('insAmount')) {
                      alertBox('حداقل خرید برای اعمال این کد تخفیف ' + convertToPersian(String(numberFormat(res.data.split('*')[1]))) + ' تومان است')
                    } else if (res.data == 'full') {
                      alertBox('اعتبار این کد به پایان رسیده است')
                    } else if (res.data == 'notMatch') {
                      alertBox('این کد تخفیف مخصوص این فروشگاه نیست')
                    }
                  }
                  else {
                    alertBox('تخفیف اعمال شد','success')
                    this.useRewardFlag = true
                    this.rewardAmount = res.data
                  }
                })
            }
        },
        expierDamp(){
            this.isDamp = false
            this.dampVal = ''
        },
        clearDamp(){
            this.rewardAmount = 0
            this.useRewardFlag = false
        },
        deleteBasket(){
            let index = this.basketArray.findIndex(elem => elem[2] == this.basketSupplierID)
            this.basketArray.splice(index,1)
            localStorage.setItem('basket', JSON.stringify(this.basketArray))
            alertBox('سبد خرید این فروشگاه پاک شد','info',2)
            if (this.basketArray.length) {
                localStorage.setItem('bsID', this.basketArray[0][2])
            }else{
                this.clearBasket()
            }
            this.getSupplierNames()
            this.getBasket()
        },
        deleteBasketInTrack(){
            if(this.basketArray){
                let index = this.basketArray.findIndex(elem => elem[2] == this.basketSupplierID)
                this.basketArray.splice(index,1)
                localStorage.setItem('basket', JSON.stringify(this.basketArray))
                if (this.basketArray.length) {
                    localStorage.setItem('bsID', this.basketArray[0][2])
                }else{
                    this.clearBasket()
                }
                this.getSupplierNames()
                this.getBasket()
            }
        },
        clearBasket(){
            localStorage.removeItem('basket')
            localStorage.removeItem('bsID')
            // alertBox('سبد خرید خالی است','info',2)
            this.getBasket()
        },
        setPaymentMethod(type) {
            if (type == 1) {
                this.useWalletFlag = false
                this.amount += this.wallet
            } else if (type == 2) {
                this.useWalletFlag = true
                this.amount -= this.wallet
                this.isCustomShown = false
            }
           this.getBasket() 

        },
        getCustomWallet(){
            let txt = `
            <table class="table" >
                <tbody>
                    <tr style="border-bottom:1px solid #e7d4d4">
                        <th>حساب اصلی :</th>
                        <th class="text-end"> ${convertToPersian(String(numberFormat(this.wallet - this.customWallet)))} تومان</th>
                    </tr>
                    <tr style="border-bottom:1px solid #e7d4d4">
                        <th>حساب فروشگاه :</th><th class="text-end"> ${convertToPersian(String(numberFormat(this.customWallet)))} تومان</ht>
                    </tr>
                    <tr style="font-size:16px;font-weight:700">
                        <th>مجموع :</th><th class="text-end"> ${convertToPersian(String(numberFormat(this.wallet)))} تومان</th>
                    </tr>
                </tbody>
            <table>
            `;
            silverBox({
                title: {
                    text: 'جزئیات موجودی کیف پول :',
                },
                html : txt,
                color : 'black',
                cancelButton: {
                    bgColor: "",
                    borderColor: "",
                    className: "w-50 mx-auto ",
                    closeOnClick: true,
                    loadingAnimation: true,
                    onClick: null,
                    showButton: true,
                    text: "متوجه شدم",
                    textColor: "",
                },
                direction: "rtl",
        });
        }
    }
})